module.exports = __webpack_public_path__ + "static/media/SellersOrders.f8dcea1f.png";